import Bloodhound from 'bloodhound-js';

export default class Typeahead {
  constructor() {
    const typeaheadFields = document.querySelectorAll('.typeahead');
    if (typeaheadFields.length) {
      for (const field of typeaheadFields) {
        this.initialize(field)
      }
    }
  }

  initialize(element) {
    const items = new Bloodhound({
      datumTokenizer: Bloodhound.tokenizers.obj.whitespace('value'),
      queryTokenizer: Bloodhound.tokenizers.whitespace,
      remote: {
        url: element.dataset.url + `${ element.dataset.url.includes('?') ? '&' : '?' }q=%QUERY`,
        wildcard: '%QUERY',
      },
    });

    $(element).typeahead({
      hint: true,
      highlight: true,
      showHintOnFocus: true,
      minLength: 0
    }, {
      source: items,
      display: 'label',
      templates: {
        suggestion: function(data) {
          return `<div>${ data.label }</div>`;
        }
      }
    }).bind('typeahead:select', function(event, suggestion) {
      /**
       * This is to auto select the provider based on the domain chosen
       * on this page `/o/{orgName}/domains/add`
       */
      if (event.target.classList.contains('is-add-domain')) {
        const select = $('#domain_create_my_cloud_account_id')
        select.val(suggestion.provider_id).trigger('chosen:updated')
      }
    });

    $('.tt-menu').css({'max-height': '280px', 'overflow-y': 'auto'});
    $('.twitter-typeahead').css('display', 'block');
  }
}
